<div class="product-list-card">
  @if (loader) {
    <div class="copy-mask">
      <ng-casto-loader></ng-casto-loader>
    </div>
  }
  <span class="casto-title large">Liste <span class="blue">d'achat</span></span>
  <div class="project-total-card expanded">
    <div class="project-total-header">
      <div>
        <span class="project-total-label">Total général du projet</span>
      </div>
      <span class="project-total-amount">{{ totalAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
    </div>
    <div class="project-total-breakdown">
      @for (entry of totalsBySupplier; track entry.supplierName) {
        <div class="project-total-row">
          <span>{{ entry.supplierName }}</span>
          <span>{{ entry.total | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
        </div>
      }
    </div>
    
  </div>


  <div class="product-list-section">
    <div class="product-list-summary">
      <div class="product-list-info">
        <div class="section-title fw-semibold">Produit(s)</div>
        <div class="product-stats">
          <span class="blue">{{ products.length }} produit{{ products.length > 1 ? 's' : '' }}</span>
          @if (products.length > 0) {
            <span class="expand-all-toggle" (click)="toggleAllRows()">
              {{ allRowsExpanded ? 'Tout replier' : 'Tout déplier' }}
              <fa-icon [icon]="allRowsExpanded ? faChevronDown : faChevronRight"></fa-icon>
            </span>
          }
        </div>
      </div>
      <div class="total-amount">
        {{ totalAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
      </div>
    </div>

    <div class="products-table-container" [ngStyle]="tableMaxHeight ? { 'max-height': tableMaxHeight } : {}">
      <p-table
        [value]="products"
        dataKey="externalId"
        [expandedRowKeys]="expandedRows"
        [scrollable]="true"
        scrollHeight="flex"
        styleClass="casto-table products-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-toggle" scope="col"></th>
            <th class="col-ean" scope="col">EAN</th>
            <th class="col-supplier" scope="col">
              <button
                type="button"
                class="sortable-header"
                [class.active]="isSortActive(CarpentryProductListSortField.SupplierName)"
                (click)="onSortToggle(CarpentryProductListSortField.SupplierName)">
                <span>{{ 'popins.products_list.main.columns.supplier' | translate }}</span>
                <fa-icon
                  class="sort-indicator"
                  [class.active]="isSortActive(CarpentryProductListSortField.SupplierName)"
                  [icon]="getSortIcon(CarpentryProductListSortField.SupplierName)"></fa-icon>
              </button>
            </th>
            <th class="col-designation" scope="col">
              <button
                type="button"
                class="sortable-header"
                [class.active]="isSortActive(CarpentryProductListSortField.Name)"
                (click)="onSortToggle(CarpentryProductListSortField.Name)">
                <span>{{ 'popins.products_list.main.columns.designation' | translate }}</span>
                <fa-icon
                  class="sort-indicator"
                  [class.active]="isSortActive(CarpentryProductListSortField.Name)"
                  [icon]="getSortIcon(CarpentryProductListSortField.Name)"></fa-icon>
              </button>
            </th>
            <th class="col-discount" scope="col">Remise</th>
            <th class="col-tva" scope="col">TVA</th>
            <th class="col-price" scope="col">Prix unitaire TTC</th>
            <th class="col-qty" scope="col">Quantité</th>
            <th class="col-price" scope="col">Total TTC</th>
            @if (!readOnly) {
              <th class="col-actions" scope="col">Actions</th>
            }
            <th class="col-reference" scope="col">Réf. Elcia</th>
            <th class="col-status" scope="col">Statut</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-record let-expanded="expanded">
          <tr [pRowToggler]="record" class="row-expandable">
            <td class="col-toggle">
              <button type="button" class="toggler-btn">
                <fa-icon [icon]="expanded ? faChevronDown : faChevronRight"></fa-icon>
              </button>
            </td>
            <td class="col-ean">{{ record.ean }}</td>
            <td class="col-supplier">{{ record.supplierName }}</td>
            <td class="col-designation">{{ record.name }}</td>
            <td class="col-discount" (click)="$event.stopPropagation()">
              <p-dropdown
                [options]="discountOptionsMap[record.externalId]"
                [(ngModel)]="record.discount"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [disabled]="readOnly"
                (onChange)="onDiscountChange(record, $event.value)">
              </p-dropdown>
            </td>
            <td class="col-tva" (click)="$event.stopPropagation()">
              <p-dropdown
                [options]="tvaOptions"
                [(ngModel)]="record.tva"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [disabled]="readOnly"
                (onChange)="onTvaChange(record)">
              </p-dropdown>
            </td>
            <td class="col-price">
              <div class="price-cell">
                @if (record.discount > 0) {
                  <span class="price-striked">{{
                    record.unitPriceTtc | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  }}</span>
                }
                <span>{{ record.unitPriceDiscountTtc | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
              </div>
            </td>
            <td class="col-qty" (click)="$event.stopPropagation()">
              <input
                type="number"
                min="1"
                [(ngModel)]="record.quantity"
                class="qty-input"
                [disabled]="readOnly"
                (change)="onQuantityChange(record)" />
            </td>
            <td class="col-price">
              <div class="price-cell">
                @if (record.discount > 0) {
                  <span class="price-striked">{{
                    record.totalPriceTtc | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  }}</span>
                }
                <span>{{ record.totalPriceDiscountTtc | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
              </div>
            </td>
            @if (!readOnly) {
              <td class="col-actions" (click)="$event.stopPropagation()">
                <div class="action-btns">
                  <button class="action-btn blue" (click)="editRecord(record)" title="Modifier">
                    <fa-icon [icon]="faPen"></fa-icon>
                  </button>
                  <button class="action-btn blue" (click)="copyRecord(record)" title="Dupliquer">
                    <fa-icon [icon]="faCopy"></fa-icon>
                  </button>
                  <button class="action-btn red" (click)="deleteRecord(record)" title="Supprimer">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </td>
            }
            <td class="col-reference">
              @if (hasSupplierSendingError(record)) {
                <span class="reference-error">
                  {{ 'popins.products_list.main.columns.supplier-sending-error' | translate }}
                </span>
              } @else {
                {{ record.referenceElcia || '' }}
              }
            </td>
            <td class="col-status">
              @if (isPendingOrderNumber(record) || hasUnknownOrderNumber(record)) {
                <span
                  class="status-chip pending-order-number actionable"
                  (click)="$event.stopPropagation(); orderEdition.emit()">
                  @if (record.orderNumber) {
                    {{ 'popins.products_list.main.columns.supplier-check-order-number-again' | translate }}
                  } @else {
                    {{ 'popins.products_list.main.columns.supplier-pending-order-number' | translate }}
                  }
                </span>
              } @else {
                <span class="status-chip"
                  [class.sent]="record.supplierSent"
                  [class.pending-payment]="isWaitingPayment(record)">
                  @if (record.supplierSent) {
                    {{ 'popins.products_list.main.columns.supplier-sent-status' | translate }}
                  } @else if (isWaitingPayment(record)) {
                    {{ 'popins.products_list.main.columns.supplier-pending-payment-notif' | translate }}
                  } @else {
                    {{ 'popins.products_list.main.columns.supplier-pending-status' | translate }}
                  }
                </span>
              }
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-record>
          <tr class="expansion-row">
            <td [attr.colspan]="readOnly ? 10 : 11">
              <div class="expansion-content">
                @if (record.thumbnail) {
                  <img class="expansion-thumbnail" [src]="record.thumbnail" [alt]="record.name" />
                }
                <div class="expansion-infos">
                  @for (info of record.informations; track info.id) {
                    <div class="info-item">{{ info.label }}</div>
                  } @empty {
                    <span class="no-info">Aucune information disponible</span>
                  }
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="add-product-bar">
    @if (displayPrintBtn) {
      <button class="btn-print" (click)="onPrint()">Imprimer</button>
    }
    @if (!readOnly) {
      <button class="btn-add-product" (click)="onAddProduct()">Ajouter un produit</button>
    }
    @if (displayCloseBtn) {
      <button class="btn-close" (click)="onClose()">Fermer</button>
    }
  </div>
</div>
